/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Suggestion
 */
export interface Suggestion {
    /**
     * 
     * @type {string}
     * @memberof Suggestion
     */
    status?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Suggestion
     */
    exact_suggestion_string?: Array<string>;
}

/**
 * Check if a given object implements the Suggestion interface.
 */
export function instanceOfSuggestion(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SuggestionFromJSON(json: any): Suggestion {
    return SuggestionFromJSONTyped(json, false);
}

export function SuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Suggestion {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : json['status'],
        'exact_suggestion_string': !exists(json, 'exact_suggestion_string') ? undefined : json['exact_suggestion_string'],
    };
}

export function SuggestionToJSON(value?: Suggestion | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'exact_suggestion_string': value.exact_suggestion_string,
    };
}

